$('body').on('submit', 'form', function (e) {
    if ($(this).hasClass('ajax-form')) {
        e.preventDefault();

        let self = this;
        $('.form-control').removeClass('is-invalid');
        $('.form-check-input').removeClass('is-invalid');

        $('.error-tab').removeClass('error-tab');

        let action = $(self).attr('action');
        let formData = new FormData(this);
        let method = $(self).attr('method');
        if (!method) {
            method = "post";
        }

        // if ($(self).hasClass('update-form')) {
        //     let loc = $(self).data('check');
        //     let loadedTime = localStorage.getItem('loadedTime');
        //     axios.get(loc).then(resp => {
        //         if (moment(loadedTime).isAfter(moment(resp.data))) {
        //             sendForm(action, method, formData)
        //         } else {
        //             $('.validation-alert').removeClass('d-none');
        //         }
        //     });
        // } else {
            sendForm(self, action, method, formData)
        // }

    }
});

function sendForm(self, action, method, formData) {
    let submitButton = $(self).find('button[type=submit]').first();
    let oldSubmitMessage = submitButton.val() ? submitButton.val() : submitButton.text();
    if (submitButton) {
        submitButton.html(
            '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Lädt...'
        );
        submitButton.prop('disabled', true);
    }

    $.ajax({
        url: action,
        method: method,
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        complete: function (result) {
            if (submitButton) {
                submitButton.val(oldSubmitMessage).text(oldSubmitMessage);
            }
            submitButton.prop('disabled', false);
        },
        error: function (result) {
            let data = result.responseJSON;
            let errors = data.errors;

            if (!jQuery.isEmptyObject(errors)) {
                for (let field in errors) {
                    if (!errors.hasOwnProperty(field)) continue;
                    let message = errors[field][0];
                    let inputField = $(':input[name="' + field + '"]').first();
                    if (inputField.attr('class') === undefined) {
                        inputField = $('#' + field);
                    }
                    if(field.includes('.')) inputField = $(':input[id="' + field + '"]').first();
                    inputField.addClass('is-invalid');
                    inputField.closest('.form-group').find('.invalid-feedback').html(message);
                    inputField.closest('.custom-control').find('.invalid-feedback').html(message);

                    let tab = inputField.closest('.tab-pane');
                    if(tab) {
                        let tablink = $('a[href="#' + tab.attr('id') + '"]');
                        $('.active').removeClass('active');
                        tablink.addClass('error-tab');
                        tablink.addClass('active');
                        tab.addClass('active');
                    }
                }
                Swal.fire({
                    icon: 'error',
                    title: 'Fehler',
                    text: 'Bitte überprüfen Sie Ihre Eingaben!.',
                    toast: true,
                    showConfirmButton: false,
                    position: 'top-end',
                    timer: 3000
                });
            }

            if(result.status === 419) {
                Swal.fire({
                    icon: 'error',
                    title: 'Fehler',
                    text: 'Formular abgelaufen! Bitte Seite neu laden und erneut versuchen.',
                    toast: true,
                    showConfirmButton: false,
                    position: 'top-end',
                    timer: 3000
                });
            }
        },
        success: function (result) {
            if (result.hasOwnProperty('redirect') && result.redirect != null) {
                document.location.href = result.redirect;
            }
        }
    });
}
